import { render, staticRenderFns } from "./PromotionPrice.vue?vue&type=template&id=f511cb64&scoped=true&"
import script from "./PromotionPrice.vue?vue&type=script&lang=js&"
export * from "./PromotionPrice.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPrice.vue?vue&type=style&index=0&id=f511cb64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f511cb64",
  null
  
)

export default component.exports